export enum MetricType {
  CUSTOMERS = 'CUSTOMERS',
  ADMISSION_GROUPS = 'ADMISSION_GROUPS',
  TRACKING_EVENTS = 'TRACKING_EVENTS',
  ORGANIZATIONS = 'ORGANIZATIONS',
  VENUES = 'VENUES',
}

export const VENUE_LEVEL_METRIC_TYPES = [
  MetricType.CUSTOMERS,
  MetricType.ADMISSION_GROUPS,
  MetricType.TRACKING_EVENTS,
] as const

export const ADMIN_PLATFORM_METRIC_TYPES = [
  MetricType.ORGANIZATIONS,
  MetricType.VENUES,
] as const

export enum MetricPeriod {
  DAILY = 'daily',
  // WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  // LIFETIME = 'lifetime',
}

export enum MetricJob {
  VENUE_METRIC_GENERATE = 'VENUE_METRIC_GENERATE',
}
